import React, { PureComponent } from "react";
import styled from "styled-components";

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  font-size: 30px;
`;

class TypeResidenceVirtual extends PureComponent {
  render() {
    return <Div>Coming Soon virtual</Div>;
  }
}

export default TypeResidenceVirtual;



// WEBPACK FOOTER //
// ./src/containers/TypeResidenceVirtual.js